// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2bkHL","name":"Header_name__2f93B","birthday":"Header_birthday__2y1hi","skeleton":"Header_skeleton__sXU5u"};